import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useConfirmPayment from 'hooks/query/useConfirmPayment'
import { useSaveUtm } from 'hooks/query/useSaveUtm'
import { Spinner } from 'components/atom/Spinner'
import useGetBillingCustomerKey from 'hooks/query/brandpay/useGetBillingCustomerKey'
import useUserStore from 'store/useUserStore'
import usePlanStore from 'store/usePlanStore'
import useConfirmPoint from 'hooks/query/point/useConfirmPoint'
import useGetAutoChargeList from 'hooks/query/point/useGetAutoChargeList'
import classNames from 'classnames'
import { useGetPointOrderId } from 'hooks/query/point/usetGetPoinOrderId'
import { RequestPurchasePoint } from 'service/point'
import { CashPaymentModal } from 'components/payment/CashPaymentModal'
import { useGetMyPoint } from 'hooks/query/point/useGetMyPoint'
import { purchaseTrack } from 'utils/metaAd'

export const PaymentSuccess = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const userInfo = useUserStore((state: any) => state.userInfo)
  const { mutate: customerkeyMutate } = useGetBillingCustomerKey()
  const [customerKey, setCustomerKey] = useState<string>('')
  const [isBrandPaymentModal, setBrandPaymentModal] = useState<boolean>(false)

  const paymentKey = urlParams.get('paymentKey')
  const subscriptionType = urlParams.get('subscriptionType')
  const orderId = urlParams.get('orderId')
  const amount = urlParams.get('amount')
  const path = urlParams.get('path')
  const planId = urlParams.get('planId')
  const paymentType = urlParams.get('type')
  const close = urlParams.get('close')
  const refetch = useUserStore((state: any) => state.refetch)
  const planRefetch = usePlanStore((state: any) => state.planRefetch)

  const { data: autoChargeList, isPending } = useGetAutoChargeList()
  const { data: myPointData, refetch: getMyPointRefetch } = useGetMyPoint()
  const setPlanRefetch = usePlanStore((state: any) => state.setRefetch)
  const navigate = useNavigate()
  const { mutate: confirmPaymentMutate, isPending: planPending } =
    useConfirmPayment()
  const { mutate: confirmPointMutate, isPending: pointPending } =
    useConfirmPoint()
  const { mutate: pointOrderIdMutate } = useGetPointOrderId()

  const { mutate: saveUtmMutate } = useSaveUtm()
  const [paymentAmount, setPaymentAmount] = useState(0)
  const [autoClose, setAutoClose] = useState<string | null>(null)
  const [isCashPaymentModal, setCashPaymentModal] = useState<boolean>(false)
  const [requestPurchasePoint, setRequestPurchasePoint] =
    useState<RequestPurchasePoint>({ orderId: '' })

  const handleCashPaymentModal = () => {
    if (userInfo) {
      pointOrderIdMutate(undefined, {
        onSuccess: (data) => {
          setRequestPurchasePoint(data)
          setCashPaymentModal(true)
        },
        onError: () => {},
      })
    } else {
      navigate('/sign-up')
    }
  }

  useEffect(() => {
    if (paymentKey && orderId && amount) {
      const confirmPaymentParams = {
        paymentKey,
        orderId,
        amount: Number(amount),
      }

      if (paymentType === 'point') {
        confirmPointMutate(confirmPaymentParams, {
          onSuccess: (data: any) => {
            if (window.gtag) {
              // <!-- Event snippet for 캐시충전하기 conversion page -->
              window.gtag('event', 'conversion', {
                send_to: 'AW-677452397/xmAXCLLB3IwaEO20hMMC',
                value: Number(amount),
                currency: 'KRW',
              })
              // meta pixel
              purchaseTrack({
                value: Number(amount),
                contentName: '포인트',
                contentType: 'point',
              })
            } else {
              console.error('gtag is not defined')
            }
            if (close === 'null') {
              setAutoClose(null)
            } else {
              setAutoClose(close)
            }

            setPaymentAmount(Number(amount))
            navigate(`${window.location.pathname}?type=${paymentType}`, {
              replace: true,
            })
          },
          onError: (e: any) => {
            navigate(
              `/payment-fail?path=my-cash-dashboard&type=${paymentType}&message=${
                e?.response?.data?.message ?? ''
              }`
            )
          },
        })
      }
      if (paymentType === 'plan') {
        confirmPaymentMutate(confirmPaymentParams, {
          onSuccess: (data) => {
            console.log('연간 plan 결제 성공:', planId)
            if (subscriptionType === 'annual') {
              if (window.gtag) {
                if (Number(planId) === 3) {
                  console.log('프리미엄')
                  // <!-- Event snippet for 캐시충전하기 conversion page -->
                  window.gtag('event', 'conversion', {
                    send_to: 'AW-677452397/WhajCKnB3IwaEO20hMMC',
                    value: Number(amount),
                    currency: 'KRW',
                  })
                  // meta pixel
                  purchaseTrack({
                    value: Number(amount),
                    contentName: '프리미엄',
                    contentType: 'plan_3_annual',
                  })
                } else if (Number(planId) === 2) {
                  // <!-- Event snippet for 캐시충전하기 conversion page -->
                  window.gtag('event', 'conversion', {
                    send_to: 'AW-677452397/4xgXCKbB3IwaEO20hMMC',
                    value: Number(amount),
                    currency: 'KRW',
                  })
                  // meta pixel
                  purchaseTrack({
                    value: Number(amount),
                    contentName: '프로',
                    contentType: 'plan_2_annual',
                  })
                } else if (Number(planId) === 1) {
                  // <!-- Event snippet for 캐시충전하기 conversion page -->
                  window.gtag('event', 'conversion', {
                    send_to: 'AW-677452397/w5kqCKPB3IwaEO20hMMC',
                    value: Number(amount),
                    currency: 'KRW',
                  })
                  // meta pixel
                  purchaseTrack({
                    value: Number(amount),
                    contentName: '라이트',
                    contentType: 'plan_1_annual',
                  })
                } else if (Number(planId) === 5) {
                  // <!-- Event snippet for 캐시충전하기 conversion page -->
                  // window.gtag('event', 'conversion', {
                  //   send_to: 'AW-677452397/w5kqCKPB3IwaEO20hMMC',
                  //   value: Number(amount),
                  //   currency: 'KRW',
                  // })
                  // meta pixel
                  purchaseTrack({
                    value: Number(amount),
                    contentName: '숏폼 스페셜',
                    contentType: 'plan_5_annual',
                  })
                }
              } else {
                console.error('gtag is not defined')
              }
            }

            setPaymentAmount(Number(amount))

            navigate(
              `${window.location.pathname}?type=${paymentType}&planId=${planId}`,
              {
                replace: true,
              }
            )
          },
          onError: (e: any) => {
            navigate(
              `/payment-fail?path=price-guide&type=${paymentType}&message=${
                e?.response?.data?.message ?? ''
              }`
            )
          },
        })
      }
    } else if (amount) {
      if (subscriptionType === 'monthly') {
        console.log('월 구독 plan 결제 성공:', planId)
        if (window.gtag) {
          if (Number(planId) === 3) {
            console.log('프리미엄')
            // <!-- Event snippet for 캐시충전하기 conversion page -->
            window.gtag('event', 'conversion', {
              send_to: 'AW-677452397/d3y7CKDB3IwaEO20hMMC',
              value: Number(amount),
              currency: 'KRW',
            })
            // meta pixel
            purchaseTrack({
              value: Number(amount),
              contentName: '프리미엄',
              contentType: 'plan_3_monthly',
            })
          } else if (Number(planId) === 2) {
            // <!-- Event snippet for 캐시충전하기 conversion page -->
            window.gtag('event', 'conversion', {
              send_to: 'AW-677452397/9xdDCJ3B3IwaEO20hMMC',
              value: Number(amount),
              currency: 'KRW',
            })
            // meta pixel
            purchaseTrack({
              value: Number(amount),
              contentName: '프로',
              contentType: 'plan_2_monthly',
            })
          } else if (Number(planId) === 1) {
            // <!-- Event snippet for 캐시충전하기 conversion page -->
            window.gtag('event', 'conversion', {
              send_to: 'AW-677452397/YPKYCJrB3IwaEO20hMMC',
              value: Number(amount),
              currency: 'KRW',
            })
            // meta pixel
            purchaseTrack({
              value: Number(amount),
              contentName: '라이트',
              contentType: 'plan_1_monthly',
            })
          } else if (Number(planId) === 5) {
            // <!-- Event snippet for 캐시충전하기 conversion page -->
            // window.gtag('event', 'conversion', {
            //   send_to: 'AW-677452397/YPKYCJrB3IwaEO20hMMC',
            //   value: Number(amount),
            //   currency: 'KRW',
            // })
            // meta pixel
            purchaseTrack({
              value: Number(amount),
              contentName: '숏폼 스페셜',
              contentType: 'plan_5_monthly',
            })
          }
        } else {
          console.error('gtag is not defined')
        }
      }
      setPaymentAmount(Number(amount))
      navigate(`${window.location.pathname}?type=plan&planId=${planId}`, {
        replace: true,
      })
    }
  }, [paymentKey, orderId, amount])

  useEffect(() => {
    if (planRefetch) {
      planRefetch()
    }
    if (refetch) {
      refetch()
    }
  }, [])

  useEffect(() => {
    console.log(autoClose, 'autoClose')
    if (autoClose) {
      window.close()
    }
  }, [autoClose])

  return (
    <div className=" relative   md:max-w-[816px] md:min-h-[100vh] max-w-[375px] my-0 mx-auto flex flex-col px-[16px]">
      <div className="flex justify-center font-bold text-[48px]">
        <p>
          {paymentType === 'plan' && Number(planId) !== 5
            ? '상품 영상 플랜 결제 완료'
            : '결제 완료'}
        </p>
      </div>
      {pointPending || planPending ? (
        <>
          {' '}
          <Spinner />
        </>
      ) : (
        <>
          <div className="flex flex-col gap-4 px-8 py-6 font-bold bg-[#F6F8FB] rounded-[20px] mt-8">
            <div className="flex justify-between">
              <p>금액</p>
              <p>
                {Number(
                  (paymentAmount * (10 / 11)).toFixed(0)
                ).toLocaleString()}
                원
              </p>
            </div>
            <div className="flex justify-between">
              <p>VAT(부가세10%)</p>
              <p>
                {Number((paymentAmount * (1 / 11)).toFixed(0)).toLocaleString()}
                원
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-4 px-8 py-5 font-bold bg-[#AFECEC] rounded-[20px] mt-2">
            <div className="flex justify-between">
              <p>총 결제금액</p>
              <p>{paymentAmount.toLocaleString()}원</p>
            </div>
          </div>

          {paymentType === 'plan' && Number(planId) === 5 && (
            <>
              {' '}
              <div className="flex justify-between gap-4 mt-5 font-bold text-[18px]">
                <button
                  className="bg-href text-[white] w-full h-[60px] flex justify-center items-center rounded-full 1"
                  onClick={() => {
                    planRefetch()
                    refetch()
                    navigate('/video-editor')
                  }}
                >
                  상품 숏폼 영상 만들러 가기
                </button>
              </div>
            </>
          )}
          {paymentType === 'plan' && Number(planId) !== 5 && (
            <>
              <div className="bg-[#F6F8FB] md:px-[32px]  p-5 flex flex-col rounded-[20px] mt-10 md:w-full">
                <div className="font-bold md:text-[24px]">
                  <p className="text-center">
                    <span className="text-[64px]">🙋🏻</span>
                    <br />
                    <span className="font-bold text-[24px]">
                      <span className="text-[#FF8800]">상품 숏폼 영상</span>도
                      만드실 계획이라면!
                    </span>{' '}
                    <br />
                    <span className="font-bold text-[18px] ">
                      상품 숏폼 영상은{' '}
                      <span className="text-main">상품 영상 플랜 사용자</span>에
                      한해서{' '}
                      <span className="text-main">패스트컷 캐시를 사용</span>
                      해서 생성할 수 있어요!
                    </span>
                  </p>
                </div>

                <div className="bg-white mt-4 p-5 md:p-7 rounded-[10px] text-[16px] md:text-[18px]">
                  {autoChargeList?.chargeMap?.total?.map((el, index) => (
                    <>
                      <div className="flex gap-[8px] items-center justify-between">
                        <p className="font-bold flex items-center">
                          {Number(el.chargeAmount).toLocaleString()}캐시
                          {Number(el.chargeAmount) === 100000 && (
                            <span className="bg-main text-white rounded-[4px] md:px-3 px-1 py-0.5 md:py-[4px] md:text-[18px] text-[10px] font-bold md:ml-2 ml-1  ">
                              인기
                            </span>
                          )}
                        </p>
                        {Number(el.bonusRate) > 0 && (
                          <div className="flex flex-col items-end text-[12px] md:text-[18px]">
                            <p className="font-bold ">
                              {' '}
                              + {`${el.bonus.toLocaleString()}`} 캐시 보너스
                            </p>
                            <p className="md:text-[14px] text-[12px]">
                              {autoChargeList.benefitInfo
                                ?.affiliateDescription && '제휴 혜택'}
                              {autoChargeList.benefitInfo?.inviteCode &&
                                '초대 코드'}
                              {autoChargeList.benefitType === 'purchase' &&
                                '충전 혜택'}
                              {` `}
                              <span
                                className={classNames(
                                  'font-bold px-1 rounded-[4px]',
                                  {
                                    'text-error bg-[#EEF1F7]':
                                      Number(el.bonusRate) <= 9,
                                    'bg-error text-white':
                                      Number(el.bonusRate) > 9,
                                  }
                                )}
                              >
                                {`${Number(el.bonusRate).toFixed(0)}%`}
                              </span>
                            </p>
                          </div>
                        )}
                      </div>
                      {index !== autoChargeList.chargeMap.total.length - 1 && (
                        <hr className="h-[1px] bg-[#EEF1F7] my-[20px]" />
                      )}
                    </>
                  ))}
                </div>
              </div>
              <div className="flex justify-between gap-4 mt-5 font-bold text-[18px]">
                <button
                  className="bg-[#2E343D] text-[white] w-[50%] h-[60px] flex justify-center items-center rounded-full 1"
                  onClick={() => {
                    planRefetch()
                    refetch()
                    navigate('/video-editor')
                  }}
                >
                  상품 롱폼 영상 만들러 가기
                </button>
                <button
                  className=" w-[50%]  bg-main py-[19px] text-white rounded-[40px] font-bold text-[18px] "
                  onClick={handleCashPaymentModal}
                >
                  상품 숏폼용 캐시 충전하기
                </button>
              </div>
            </>
          )}
          <div className="flex flex-col gap-4 font-bold text-white mt-8 ">
            <div className="flex justify-center gap-4 w-full">
              {paymentType === 'point' && (
                <button
                  className="bg-[#735CFF] w-[400px] h-[60px] flex justify-center items-center rounded-full"
                  onClick={() => {
                    navigate('/short-video-editor')
                  }}
                >
                  컨텐츠 영상 만들러 가기
                </button>
              )}
            </div>
          </div>
        </>
      )}{' '}
      {isCashPaymentModal && (
        <CashPaymentModal
          setCashPaymentModal={setCashPaymentModal}
          userInfo={userInfo?.userInfo}
          affiliatePoint={userInfo?.affiliate?.point}
          userCurrentPoint={myPointData.totalPoint}
          requestPurchasePoint={requestPurchasePoint}
        />
      )}
    </div>
  )
}
